class StBrowserAlertsController {
  constructor() {
    'ngInject';
    this.name = 'stBrowserAlerts';
  }
  $onInit() {}
}

export default StBrowserAlertsController;



// WEBPACK FOOTER //
// ./client/app/common/stBrowserAlerts/stBrowserAlerts.controller.js